import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogContext, DialogService, DroplistItem, DroplistWidget } from '@eforall/dashboard';
import { AlgoliaSearchObject, ExplorableNavItem } from '@interfaces';
import { ExplorerService } from '../explorer.service';
import { EXPLORERS } from '../explorers';
import { SearchDialog, SearchDialogData } from '../search-dialog/search.dialog';

@Component({
	selector: 'explorer-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		DroplistWidget,
		EXPLORERS,
	],
	templateUrl: './explorer.dialog.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './explorer.dialog.scss',
})

export class ExplorerDialog implements OnInit {

	readonly dialogRef = inject(MatDialogRef<ExplorerDialog>);
	readonly dialogContext: DialogContext<{}> = inject(MAT_DIALOG_DATA);

	readonly dialogService = inject(DialogService);
	readonly explorer = inject(ExplorerService);
	readonly nav = this.explorer.nav;
	readonly currentNoun = computed(() => this.explorer.nav.currentItem().noun);

	ngOnInit() {
		this.explorer.setDialogBodyHeight(computed(() => this.dialogContext.dimensions().bodyHeight));
	}


	readonly recentItems = computed(() => {
		return this.explorer.nav.recents().map((item, i) => createDroplistItem(item, i));
	});

	readonly currentRecentItem = computed<DroplistItem>(() => {
		return this.recentItems()[0]!;
	});

	onItemChange(item: DroplistItem<ExplorableNavItem> | undefined) {
		if (!item?.data) return;
		this.explorer.nav.go(item.data);
	}

	goBack() {
		console.log('goBack()');
		this.nav.goBack();
	}

	goForward() {
		console.log('goForward()');
		this.nav.goForward();
	}

	async openSearchDialog() {
		const dialogData: SearchDialogData = {
			searchOnlyForPerson: false,
			objectTypes: ['Person', 'AccVenture'],
		};
		const dialogAction = await this.dialogService.showCustom(SearchDialog, { data: dialogData }, 800, 800);
		if (!dialogAction || !dialogAction.callbackResult) return;

		const selectedItem = dialogAction.callbackResult as AlgoliaSearchObject;

		const explorableItem: ExplorableNavItem = {
			noun: selectedItem.objectType === 'AccVenture' ? 'Venture' : 'Person', // change this to use the map once we have more object types
			id: selectedItem.id,
			name: selectedItem.displayName,
			hasRedFlag: false, // will be set later using updateItem once we have func data
		}
		this.explorer.nav.go(explorableItem);
	}

}


function createDroplistItem(item: ExplorableNavItem, index: number): DroplistItem {
	return {
		uniqueId: index,
		iconContext: {
			iconClass: 'fa-person',
			iconStyle: 'fa-regular',
			text: item.name,
			hideText: 'never',
		},
		data: item,
	}
}